/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import { IEligibilityStatusApiClient } from './contracts'
import axios from 'axios'
import { injectable } from 'inversify'
import { IEligibilityStatus } from '../RequestHistoryStateManager/contracts'
import { injectProperty } from '../../arc/configuration/ServiceLocator'
import { SettingsManager } from '../../configuration/SettingsManager'
import { IUserSessionMiddleware } from '../../arc/middleware/UserSessionMiddleware/contracts'
import { ErrorHelper } from '../../utils/ErrorHelper'

@injectable()
export class EligibilityStatusApiClient implements IEligibilityStatusApiClient {
	@injectProperty('IUserSessionMiddleware')
	private readonly userSessionMiddleware!: IUserSessionMiddleware

	getAllEligibilityStatuses(): Promise<IEligibilityStatus[]> {
		const url = `${SettingsManager.REACT_APP_MAIN_API_BASE_URL().value}/Eligibilitystatuses`
		return this.userSessionMiddleware.loadSessionJwt().then(token =>
			axios
				.get(url, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				.then(response => response.data.items)
				.catch(error => {
					ErrorHelper.handleApiError(error)
				}),
		)
	}
}
